import { ref, readonly } from "vue";

// Global loading state
const isLoading = ref(false);
let loadingScreenRef = null;

// Function to disable scrolling
const disableScroll = () => {
  document.body.style.overflow = "hidden";
  document.body.style.height = "100vh";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
};

// Function to enable scrolling
const enableScroll = () => {
  document.body.style.overflow = "";
  document.body.style.height = "";
  document.body.style.position = "";
  document.body.style.width = "";
};

// Set the loading screen component reference
export const setLoadingScreenRef = (ref) => {
  loadingScreenRef = ref;
};

// Show loading screen with minimum duration
export const showLoadingScreen = async (minDuration = 1000) => {
  if (!loadingScreenRef) return;

  isLoading.value = true;
  loadingScreenRef.show();
  disableScroll();

  // Return a promise that resolves after the minimum duration
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, minDuration);
  });
};

// Hide loading screen
export const hideLoadingScreen = () => {
  if (!loadingScreenRef) return;

  isLoading.value = false;
  loadingScreenRef.hide();
  enableScroll();
};

// Composable to provide loading state
export const useRouteLoading = () => {
  return {
    isLoading: readonly(isLoading),
    showLoadingScreen,
    hideLoadingScreen,
    setLoadingScreenRef,
  };
};

export { isLoading };
